import { makeAutoObservable } from "mobx";
import { DocSeriesInfo } from "~/document";
import PaginatedEndpoint from "~/util/PaginatedEndpoint";
import notifStore from "./notifications";

export class DocSeriesStore {
  f = new PaginatedEndpoint<DocSeriesInfo>("third-types", notifStore);

  get loaded() {
    return this.f.items;
  }

  constructor() {
    makeAutoObservable(this);
  }
}

const docSeriesStore = new DocSeriesStore();

export default docSeriesStore;
